import React, { Component } from 'react'
import classnames from "classnames";

import baseStyles from 'custom/base.styl';
import grid from './../../styles/grid.styl';

class TutorialStep6 extends Component {
  render() {
    return (
      <div className={classnames(baseStyles.tutorial_content_step, baseStyles.tutorial_content_step2)}>

        <h3>Beware of Bloopers</h3>
        <div className={grid.row}>
          <div className={classnames(grid.col_12)}>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default)}>
              <li>Automatic checker corrects mistakes you cannot sea</li>
              <li>Repetition of the repeated words causes repetitions</li>
              <li>The author depicts in the novel how two people meet each other and fell fall in love</li>
              <li>Academic papers do not stand beating around the bush</li>
              <li>He doesn’t seem to give up.</li>
            </ul>

            <h3>Forewarned is forearmed</h3>
            <ul className={classnames(baseStyles.custom_list, baseStyles.custom_list__default, baseStyles.mb_0)}>
              <li>Proofread the paper</li>
              <li>Use <a href="http://thesaurus.com" target="_blank" rel="noopener noreferrer">www.thesaurus.com</a> to find synonyms</li>
              <li>Stick to one group of tenses throughout the paper</li>
              <li>Avoid idioms and colloquial language</li>
              <li>Avoid personal pronouns, contracted forms, and phrasal verbs</li>
              <li>Remember that the sentence should be 10-35 words long</li>
            </ul>
          </div>
        </div>
      </div>

    )
  }
}

export default TutorialStep6;



// WEBPACK FOOTER //
// ./src/components/Tutorial/TutorialStep6.js